/*
フォームの確認ページでのブラウザバックをフォーム内の戻るボタンクリックに差し替える

※Chromeはページ上を1回以上クリックされないと動作しないため、完全な対策ではない
https://qiita.com/ryoutancobu/items/eb908659e109c19ab1e1#chrome%E3%82%84androidwebview%E3%81%A7%E3%81%AFpopstate%E3%81%AF%E5%8B%95%E3%81%8B%E3%81%AA%E3%81%84

MW WP Formの戻るボタン「[name="submitBack"]」または「.js-backBtn」をクリックする形で反応する
*/

const backBtn = document.querySelector('.js-backBtn,[name="submitBack"]')
if (backBtn) {
  history.pushState(null, null, null) // 空の履歴を入れてブラウザバック無効化
  //ブラウザバックボタン押下時
  window.addEventListener('popstate', function (e) {
    // console.log('replace')
    history.pushState(null, null, null)
    backBtn.click() // フォーム内の戻るボタンを押す
  })
}
